export const FEEDBACK_ON_DEMAND_STATUSES = {
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  IN_PROGRESS: 'In Progress',
  REJECTED: 'Rejected',
  COMPLETED: 'Completed'
};

export const getFeedbackStatusColor = (status) => {
  switch (status) {
    case FEEDBACK_ON_DEMAND_STATUSES.PENDING:
      return '#FEF3C7'; // Light amber background
    case FEEDBACK_ON_DEMAND_STATUSES.ACCEPTED:
      return '#EBF5FF'; // Light blue background
    case FEEDBACK_ON_DEMAND_STATUSES.IN_PROGRESS:
      return '#EEF2FF'; // Light indigo background
    case FEEDBACK_ON_DEMAND_STATUSES.REJECTED:
      return '#FEE2E2'; // Light red background
    case FEEDBACK_ON_DEMAND_STATUSES.COMPLETED:
      return '#E2F8E9'; // Light green background
    default:
      return '#F1F5F9'; // Light slate background
  }
};

export const getFeedbackStatusText = (status) => {
  switch (status) {
    case FEEDBACK_ON_DEMAND_STATUSES.PENDING:
      return 'Pending';
    case FEEDBACK_ON_DEMAND_STATUSES.ACCEPTED:
      return 'Accepted';
    case FEEDBACK_ON_DEMAND_STATUSES.IN_PROGRESS:
      return 'In Progress';
    case FEEDBACK_ON_DEMAND_STATUSES.REJECTED:
      return 'Rejected';
    case FEEDBACK_ON_DEMAND_STATUSES.COMPLETED:
      return 'Completed';
    default:
      return 'Unknown Status';
  }
};

export const getFeedbackStatusBorderColor = (status) => {
  switch (status) {
    case FEEDBACK_ON_DEMAND_STATUSES.PENDING:
      return '#D97706'; // Amber border
    case FEEDBACK_ON_DEMAND_STATUSES.ACCEPTED:
      return '#2E90FA'; // Blue border
    case FEEDBACK_ON_DEMAND_STATUSES.IN_PROGRESS:
      return '#6366F1'; // Indigo border
    case FEEDBACK_ON_DEMAND_STATUSES.REJECTED:
      return '#DC2626'; // Red border
    case FEEDBACK_ON_DEMAND_STATUSES.COMPLETED:
      return '#16A34A'; // Green border
    default:
      return '#475569'; // Slate border
  }
};

export const getFeedbackStatusTextColor = (status) => {
  switch (status) {
    case FEEDBACK_ON_DEMAND_STATUSES.PENDING:
      return '#D97706'; // Amber text
    case FEEDBACK_ON_DEMAND_STATUSES.ACCEPTED:
      return '#2E90FA'; // Blue text
    case FEEDBACK_ON_DEMAND_STATUSES.IN_PROGRESS:
      return '#6366F1'; // Indigo text
    case FEEDBACK_ON_DEMAND_STATUSES.REJECTED:
      return '#DC2626'; // Red text
    case FEEDBACK_ON_DEMAND_STATUSES.COMPLETED:
      return '#16A34A'; // Green text
    default:
      return '#475569'; // Slate text
  }
};

// Helper function to determine the status based on feedback entity
export const determineFeedbackStatus = (feedback) => {
  if (!feedback) {
    return null;
  }

  if (feedback.completedAt) {
    return FEEDBACK_ON_DEMAND_STATUSES.COMPLETED;
  }
  if (feedback.rejectedAt) {
    return FEEDBACK_ON_DEMAND_STATUSES.REJECTED;
  }
  if (feedback.startedAt && !feedback.completedAt && !feedback.rejectedAt) {
    return FEEDBACK_ON_DEMAND_STATUSES.IN_PROGRESS;
  }
  if (feedback.acceptedAt && !feedback.startedAt && !feedback.completedAt) {
    return FEEDBACK_ON_DEMAND_STATUSES.ACCEPTED;
  }
  if (feedback.assignedAt && !feedback.acceptedAt) {
    return FEEDBACK_ON_DEMAND_STATUSES.PENDING;
  }
  return null;
}; 